<template>
  <Modal class="_component-login-modal" :clickOverlayClose="false">
    <div class="component-login-modal">
      <Login :options="options" ref="login" :initState="initState" @changeState="handleChangeState" />
      <div class="close-render" @click="handleClickClose" v-if="isShowClose"></div>
    </div>
    <Welfare class="welfare-wrap mt-12" modal v-if="initState !== LOGIN_STATE.FIND_PASSWORD" />
  </Modal>
</template>
<script>
import Welfare from '../Welfare';
import Modal from '../../Modal';
import Login from '../index.vue';
import LOGIN_STATE from '../loginState';
export default {
  name: 'LoginModal',
  provide() {
    return { LoginModal: this };
  },
  components: {
    Login,
    Modal,
    Welfare
  },
  props: {
    initState: {
      type: String,
      default: LOGIN_STATE.SMS
    },
    options: {
      default: () => ({})
    }
  },
  computed: {
    LOGIN_STATE() {
      return LOGIN_STATE;
    },
    isShowClose() {
      return this.state !== LOGIN_STATE.COMPLETE_INFO;
    }
  },
  data: () => ({
    state: ''
  }),
  created() {
    this.state = this.initState;
  },
  methods: {
    handleChangeState(state) {
      this.state = state;
    },
    handleClickClose: function() {
      this.$emit('close');
    }
  }
};
</script>
<style lang="less" scoped src="./index.less"></style>
